export default __webpack_public_path__ + "da5dd85a9064883f7f1b84b54bb02c9d.png";